"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChecklistPercentageLabel = exports.getChecklistPercentage = void 0;
const number_1 = require("../helpers/number");
const getChecklistPercentage = (value) => {
    if (!value) {
        return 0;
    }
    const { total_items, completed_items } = value;
    return total_items > 0 ? completed_items / total_items : 0;
};
exports.getChecklistPercentage = getChecklistPercentage;
const getChecklistPercentageLabel = (value) => `${String((0, number_1.round)((0, exports.getChecklistPercentage)(value) * 100))}%`;
exports.getChecklistPercentageLabel = getChecklistPercentageLabel;
